import { AppRouter } from './providers/router';

const App = () => {
  return <AppRouter />;
};

export default App;
